const digest = '3ae4b083a42399b0cd994d2e9b36849260f8df155c1c6e14063f9d79023a04d4';
const css = `._pageWithNav_1e393_1{min-height:100vh;padding:48px 16px}._container_1e393_6{align-items:flex-start;display:flex;gap:32px;margin:0 auto;max-width:900px}@media (max-width:768px){._container_1e393_6{flex-direction:column;gap:24px}}._content_1e393_20{background:#fff;border-radius:4px;flex:1;padding:40px}@media (max-width:768px){._content_1e393_20{padding:24px;width:100%}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'pageWithNav': '_pageWithNav_1e393_1', 'container': '_container_1e393_6', 'content': '_content_1e393_20' };
export const pageWithNav = '_pageWithNav_1e393_1';
export const container = '_container_1e393_6';
export const content = '_content_1e393_20';
export { css, digest };